import React from 'react';

const SinglePalletPacking = (props) => {
  const { barcode, measurements } = props;

  return (
    <div className="pallet-item">
      <div className="pallet-item-barcode" style={{ fontWeight: 500 }}>
        # {barcode}
      </div>
      {measurements ? (
        <div className="parameters d-flex">
          <span>{`${measurements.dimensions.width / 10} x ${
            measurements.dimensions.height / 10
          } x ${measurements.dimensions.depth / 10} cм`}</span>
          <span
            className="pallet-weight"
            style={{ marginLeft: '24px' }}
          >{`${measurements.weight} г`}</span>
        </div>
      ) : null}
    </div>
  );
};

export default SinglePalletPacking;
